import React, {useState, useEffect} from 'react';
import { connect } from 'react-redux';
import { request, deleteThis } from '../../redux/actions/genericAction';
import { Redirect} from 'react-router-dom';
import { TitleBar } from '../common/theme';
import {pipe, filter, map, sort, buildUniqueArrayFromField, toArray, convertDictionaryKeys, isObjectEmpty, differenceInDays} from '../../Utils';
import ChartComp from './ChartComp';
import DateSelectorComp from '../common/DateSelectorComp';
import StaticNav from '../common/StaticNav';
import AdminNotificationsComp from './tables/AdminNotificationsComp';
import TeacherNotificationsComp from './tables/TeacherNotificationsComp';
import ProgramsStudentsClassesComp from './tables/ProgramsStudentsClassesComp';
import ProgramsStudentsComp from './tables/ProgramStudentsComp';
import SchoolComp from './tables/SchoolComp';
import ClassesComp from './tables/ClassesComp';
import StudentsComp from './tables/StudentsComp';
import ProgramsComp from './tables/ProgramsComp';
import StudentsClassesComp from './tables/StudentsClassesComp';
import ProgramsClassesComp from './tables/ProgramsClassesComp';

// import Row from 'react-bootstrap/Row';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';

let SummaryPage = ({database, isAdmin, request, deleteThis, programs}) => {
  const [hasDatabaseData, sethasDatabaseData] = useState(true);
  const [summaryData, setSumamryData] = useState([]);
  const [studentData, setStudentData] = useState({});
  const [schoolData, setSchoolData] = useState({});
  const [classData, setClassData] = useState({});
  const [currentTab, setCurrentTab] = useState('Overview');
  const [dateRange, setDateRange] = useState([]);
  const [progChecked, setProgChecked] = useState(true);
  const [studChecked, setStudChecked] = useState(true);
  const [classChecked, setClassChecked] = useState(true);
  const [numNotifications, setNumNotifications] = useState('0');
  const [schoolNotificationData, setSchoolNotificationData] = useState([]);

  const pageState = {
    summaryData, setSumamryData,
    studentData, setStudentData,
    classData, setClassData,
    schoolData, setSchoolData,
    dateRange, setDateRange,
    programs,
    setNumNotifications,
    schoolNotificationData
  };

  const getNewDate = () =>{
    let endDate = new Date();
    let startDate = new Date();
    
    startDate.setDate(endDate.getDate()-6);
    startDate.setHours(0,0,0,0);

    setDateRange([startDate.getTime(), endDate.getTime()]);
    return [startDate.getTime(), endDate.getTime()];
  };  
  
  function getSchoolNotificationData(){        
    const {summaryData, classData, programs} = pageState;
    if(isObjectEmpty(summaryData)) return;
    
    let classIDList = buildUniqueArrayFromField(toArray(summaryData), 'classID');
    let classList = pipe(
        map(classID => classData[classID]),
        filter(classRec => classRec),
        sort((a,b) => (a.Classname.toUpperCase() > b.Classname.toUpperCase()) ? 1 : (a.Classname.toUpperCase() === b.Classname.toUpperCase() ? -1 : 0)),
    )(classIDList); 

    let numNotifications=0;
    classList = classList.map(classRec => {
        let studentData = classRec.students.sort((a, b) => 
            (a.Name.toUpperCase() < b.Name.toUpperCase()) ? -1 : (a.Name.toUpperCase() > b.Name.toUpperCase()) ? 1 : 0
        );

        let studIDList = buildUniqueArrayFromField(toArray(summaryData), 'StudentID');
        let programsPerStudent = studIDList.map( studID => { return {studID,  // iterate all student ids         
            progs: summaryData.filter( summaryRec => // group all students with the same id
                summaryRec.StudentID === studID).map(studentSummaryRec => { 
                    let dayDate = 0;
                    // console.log(studentSummaryRec.ProgID,studentSummaryRec.ProgID.toUpperCase());
                    // console.log(programs[studentSummaryRec.ProgID.toUpperCase()]);
                    if(studentSummaryRec.AssPer){                        
                        let assParts = studentSummaryRec.AssPer.split('/');
                        if(assParts[0]===assParts[1])
                            studentSummaryRec.AssPer = '100';
                    }
                    if (studentSummaryRec.AssPer==='100' || studentSummaryRec.PrePer==='100' || studentSummaryRec.PosPer==='100')
                        dayDate = studentSummaryRec.DayDate;  
                    let title = 'Removed Lesson';
                    if(studentSummaryRec.ProgID.toUpperCase() in programs)
                      title = programs[studentSummaryRec.ProgID.toUpperCase()].title;
                    return { // translate stud array - prog array                                            
                        title: title,
                        id: studentSummaryRec.ProgID.toUpperCase(),
                        assPer:(studentSummaryRec.AssPer && studentSummaryRec.AssPer!=='none')?parseInt(studentSummaryRec.AssPer):0,
                        prePer:(studentSummaryRec.PrePer)?parseInt(studentSummaryRec.PrePer):0,
                        postPer:(studentSummaryRec.PosPer)?parseInt(studentSummaryRec.PosPer):0,
                        dayDate
                    };
                }).filter(progRec=>progRec.title!=='Removed Lesson')
                  .filter(progRec=>(progRec.assPer===100 || progRec.prePer===100 || progRec.postPer===100) )
            };
        }).reduce((obj, item) => { // create a dictionary of studIDs and program lists
            obj[item.studID] = {progs:item.progs};
            return obj; 
        },{});         

        studentData = studentData.filter( studentRec => // only care about students with summary marks
            studIDList.indexOf(studentRec.StudentID) > -1
        ).map( studentRec => { 
            return {...studentRec, programData: [...programsPerStudent[studentRec.StudentID].progs] };
        }).filter( studentRec => // only care about with programData notifications
            { 
                numNotifications+=studentRec.programData.length;
                return (studentRec.programData.length > 0);
            }
        );        
        return { classData: classRec, studData: studentData };
    });
    pageState.setNumNotifications(''+numNotifications);
    classList = classList.filter(cl=>cl.studData.length!==0);
    return classList;   
  }

  useEffect(() => {
    if(!database['getCustomer'])
      return sethasDatabaseData(false);
    
    if(!database['getCustomer']) return;
    let customer = database['getCustomer'].data;
    // dateRange gets reset everytime you enter the summary screen
    let tDateRange = (dateRange.length==0) ? getNewDate(): dateRange;
    if(!database['getAllTimeMarksForSchoolByDateRange']){
      let getSummaryQuery={
        params:`${customer.ID}~${tDateRange[0]}~${tDateRange[1]}`,
        altServer:true,
        func:'getAllTimeMarksForSchoolByDateRange'            
      };

      if(!isAdmin)
        getSummaryQuery={
          params:`${sessionStorage.getItem('userID')}~${tDateRange[0]}~${tDateRange[1]}`,
          altName:'getAllTimeMarksForSchoolByDateRange',
          altServer:true,
          func:'getAllTimeMarksForClassByDateRange'            
        };
      request(getSummaryQuery); 
    }
    setClassData(database['getAllClasses'].data);    
    setStudentData(database['getAllStudentsForSchool'].data);

    // if(isObjectEmpty(schoolNotificationData))
    if(schoolNotificationData.length===0)
      setSchoolNotificationData(getSchoolNotificationData());
  });
  
  useEffect(() => {
    if(database['getAllTimeMarksForSchoolByDateRange'] && database['getAllTimeMarksForSchoolByDateRange'].isLoaded){

      let summaryData = toArray(database['getAllTimeMarksForSchoolByDateRange'].data);

      // fix a bug in pretests what show more answers correct then answers completed
      summaryData = summaryData.map(itemRec=>{
          let questionsRight=parseInt(itemRec.QuestionsRight);
          let questionsAttempted=parseInt(itemRec.QuestionsAttempted);
          itemRec.QuestionsAttempted = (questionsAttempted > questionsRight)?questionsAttempted:questionsRight;
          return itemRec;
        }
      ).filter(summaryRec=>(summaryRec.ProgID.toUpperCase() in programs));      

      setSumamryData(summaryData);  
      if(isObjectEmpty(summaryData)) return;
      
      let schoolData = summaryData.reduce((acc, summaryRec) => {
          summaryRec.QuestionsRight = (summaryRec.QuestionsRight) ? summaryRec.QuestionsRight : 0;
          summaryRec.QuestionsAttempted = (summaryRec.QuestionsAttempted) ? summaryRec.QuestionsAttempted : 0;
          summaryRec.CumulativeTime = (summaryRec.CumulativeTime) ? summaryRec.CumulativeTime : 0;
          acc.QuestionsRight += parseInt(summaryRec.QuestionsRight);
          acc.QuestionsAttempted += parseInt(summaryRec.QuestionsAttempted);
          acc.time += parseInt(summaryRec.CumulativeTime)+parseInt(summaryRec.CumulativeIdleTime); 
          acc.correct = acc.QuestionsRight + ' / ' + acc.QuestionsAttempted;
          acc.percent = Math.round(acc.QuestionsRight/acc.QuestionsAttempted*100);
          acc.logins ++;
          return acc;
      },{QuestionsRight:0, QuestionsAttempted:0, time: 0, correct:'no marks', percent:'no marks', logins:0});
      setSchoolData(schoolData); 
      setSchoolNotificationData([]);
      // let summaryData = toArray(database['getAllTimeMarksForSchoolByDateRange'].data)
      //                   .filter((summaryRec)=> summaryRec['DayDate']);
      // setSumamryData(summaryData);
    }
  }, [database['getAllTimeMarksForSchoolByDateRange']]);  

  if (!hasDatabaseData) {
    return <Redirect to='/' />;
  }
  
  return (
    <div>
        <br/>
        <StaticNav currentTopic={'Home'}/> 
        <DateSelectorComp pageState={{deleteThis, dateRange, setDateRange}}/>
        <br/>

        {currentTab==='Detail' && <>
          <TitleBar>
            <Col style={{textAlign: 'left', color: 'white' }} xs='4'><Button variant='success' onClick={()=>setCurrentTab('Overview')} >Overview</Button> <Button variant='success' disabled >Detail</Button> <Button variant='success' onClick={()=>setCurrentTab('Notifications')}>Notifications({numNotifications})</Button></Col>
            <Col xs='8'>
            <span className={'pull-right'} style={{display:'inline'}}>
                <input type="checkbox" onChange={(e)=> setProgChecked(e.target.checked)} checked={progChecked}/> Programs &nbsp;&nbsp;
                <input type="checkbox" onChange={(e)=> setStudChecked(e.target.checked)} checked={studChecked}/> Students &nbsp;&nbsp;
                {(isAdmin)&&<><input type="checkbox" onChange={(e)=> setClassChecked(e.target.checked)} checked={classChecked}/> Classes &nbsp;&nbsp;</>}
            </span>
            </Col>
          </TitleBar>
          {(summaryData.length)===0?<>
          <h4><center>There is no data for this time period</center></h4>
          </>:<>
            {(isAdmin)&&<>
              {(progChecked && studChecked && classChecked) && <ProgramsStudentsClassesComp pageState={pageState}/>}
              {(progChecked && studChecked && !classChecked) && <ProgramsStudentsComp pageState={pageState}/>}
              {(!progChecked && !studChecked && !classChecked) && <SchoolComp pageState={pageState}/>}
              {(!progChecked && !studChecked && classChecked) && <ClassesComp pageState={pageState}/>}
              {(!progChecked && studChecked && !classChecked) && <StudentsComp pageState={pageState}/>}
              {(progChecked && !studChecked && !classChecked) && <ProgramsComp pageState={pageState}/>}
              {(!progChecked && studChecked && classChecked) && <StudentsClassesComp pageState={pageState}/>}
              {(progChecked && !studChecked && classChecked) && <ProgramsClassesComp pageState={pageState}/>}
            </>}

            {(!isAdmin)&&<>
              {(progChecked && studChecked) && <ProgramsStudentsComp pageState={pageState}/>}
              {(!progChecked && !studChecked) && <ClassesComp pageState={pageState}/>}
              {(!progChecked && studChecked) && <StudentsComp pageState={pageState}/>}
              {(progChecked && !studChecked) && <ProgramsComp pageState={pageState}/>}
            </>}
          </>}
        </>}

        {currentTab==='Overview' && <>
          <TitleBar>
            <Col style={{textAlign: 'left', color: 'white' }} xs='12'><Button variant='success' disabled >Overview</Button> <Button variant='success' onClick={()=>setCurrentTab('Detail')}>Detail</Button> <Button variant='success' onClick={()=>setCurrentTab('Notifications')}>Notifications({numNotifications})</Button> </Col>
          </TitleBar>
          {(summaryData.length)===0?<>
            <h4><center>There is no data for this time period</center></h4>
          </>:<>
            <ChartComp pageState={pageState}/>
          </>}        
        </>}        

        {currentTab==='Notifications' && <>
          <TitleBar>
            <Col style={{textAlign: 'left', color: 'white' }} xs='12'><Button variant='success' onClick={()=>setCurrentTab('Overview')} >Overview</Button> <Button variant='success' onClick={()=>setCurrentTab('Detail')}>Detail</Button> <Button variant='success' disabled>Notifications({numNotifications})</Button> </Col>
          </TitleBar>
          {(summaryData.length)===0?<>
            <h4><center>There is no data for this time period</center></h4>
          </>:<>
          {(isAdmin)&&<>
              <AdminNotificationsComp pageState={pageState}/>
            </>}
            {(!isAdmin)&&<>
              <TeacherNotificationsComp pageState={pageState}/>
            </>}
          </>}        
        </>}  

    </div>
  );
};

const mapStateToProps = state => {
  return {
    database: state.genericReducer,
    isAdmin: (state.dashboardReducer.login === 'Admin'),
    programs: convertDictionaryKeys(state.rawProgramReducer.programs, 'id')
  };
};

SummaryPage = connect(
  mapStateToProps,
  { request, deleteThis }
)(SummaryPage);

export default SummaryPage;